export const API_ENDPOINTS = {
  // Auth Service
  SIGNIN: process.env.REACT_APP_AUTH_API_URL + '/signin',
  USERS: process.env.REACT_APP_AUTH_API_URL + '/users',
  REGISTER: process.env.REACT_APP_AUTH_API_URL + '/register',

  // Scan Service
  UPLOAD_SCAN: process.env.REACT_APP_SCAN_API_URL + '/uploadscan',
  UPLOAD_DEVICE: process.env.REACT_APP_SCAN_API_URL + '/uploaddevice',
  UPDATE_DEVICE: process.env.REACT_APP_SCAN_API_URL + '/updatedevice',
  GET_DEVICES: process.env.REACT_APP_SCAN_API_URL + '/getdevices',
  GET_DEVICE_BY_NAME: process.env.REACT_APP_SCAN_API_URL + '/getdevicebyname',
  UPLOAD_COLLECTIONS: process.env.REACT_APP_SCAN_API_URL + '/uploadcollections',
  GET_COLLECTIONS: process.env.REACT_APP_SCAN_API_URL + '/getcollections',
  DOWNLOAD_SCREENING: process.env.REACT_APP_SCAN_API_URL + '/downloadscreening',
  DOWNLOAD_SCREENING_BY_URL: process.env.REACT_APP_SCAN_API_URL + '/downloadscreeningbyurl',
  GET_SCREENINGS: process.env.REACT_APP_SCAN_API_URL + '/getscreenings',
};

export default API_ENDPOINTS;
